import React from "react";
import BeneficariesView from "../BeneficariesView/BeneficariesView";
import Icon1 from "../../images/gbrFarmerBenefits/pay-per-click.svg";

// Main component for Brands/Buyers
const BrandBuyers = () => {
  // Features available for Brands/Buyers 
  const features = [
    {
      image: Icon1,
      title: "Verified Supplier Network",
      bodycopy:
        "Access a trusted network of certified food processing enterprises for consistent quality.",
    },
    {
      image: Icon1,
      title: "End-to-End Traceability",
      bodycopy:
        "Track raw material sourcing, production processes, and final product delivery with full transparency.",
    },
    {
      image: Icon1,
      title: "Custom Contract Manufacturing",
      bodycopy:
        "Seamlessly collaborate with processing units for private label and bulk order production.",
    },
    {
      image: Icon1,
      title: "Quality & Compliance Assurance",
      bodycopy:
        "Ensure adherence to food safety, organic, and regulatory standards for all sourced products.",
    },
    {
      image: Icon1,
      title: "Real-Time Order & Logistics Tracking",
      bodycopy:
        "Monitor production progress, dispatch schedules, and shipment status in real time.",
    },
  ];

  // Benefits offered to Brands/Buyers in the network
  const benefits = [
    {
      image: Icon1,
      title: "Reliable & Scalable Supply Chain",
      bodycopy:
        "Ensure uninterrupted product availability with a well-managed production network.",
    },
    {
      image: Icon1,
      title: "Consistent Product Quality",
      bodycopy:
        "Work with verified food processors to maintain brand standards and customer satisfaction.",
    },
    {
      image: Icon1,
      title: "Faster Time-to-Market",
      bodycopy:
        "Reduce production lead times and speed up order fulfillment through optimized workflows.",
    },
    {
      image: Icon1,
      title: "Cost Efficiency & Bulk Savings",
      bodycopy:
        "Leverage economies of scale for competitive pricing and better profit margins.",
    },
    {
      image: Icon1,
      title: "Stronger Market Positioning",
      bodycopy:
        "Enhance brand credibility with sustainable, traceable, and high-quality products.",
    },
  ];

  return (
    <>
      {/* Component to display banner, features and benefits of the Brand/Buyer network */}
      <BeneficariesView title="Brands / Buyer" features={features} benefits={benefits} />
    </>
  );
};

export default BrandBuyers;
